var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4645 3.75H11.25C8.89298 3.75 7.71447 3.75 6.98223 4.48223C6.25 5.21447 6.25 6.39298 6.25 8.75V21.25C6.25 23.607 6.25 24.7855 6.98223 25.5178C7.71447 26.25 8.89298 26.25 11.25 26.25H18.75C21.107 26.25 22.2855 26.25 23.0178 25.5178C23.75 24.7855 23.75 23.607 23.75 21.25V11.0355C23.75 10.5246 23.75 10.2691 23.6548 10.0394C23.5597 9.8097 23.3791 9.62906 23.0178 9.26777L18.2322 4.48223C17.8709 4.12095 17.6903 3.9403 17.4606 3.84515C17.2309 3.75 16.9754 3.75 16.4645 3.75Z",
    stroke: "#33363F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 3.75V8.75C16.25 9.92851 16.25 10.5178 16.6161 10.8839C16.9822 11.25 17.5715 11.25 18.75 11.25H23.75",
    stroke: "#33363F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.e3e893d7096a7da3d631351ef95a661e.svg";
export { ForwardRef as ReactComponent };